
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AffiliatedJobsDialogLink from '@/components/jobDetailed/zammadTicketPage/AffiliatedJobsDialogLink.vue';
import AffiliatedJobsTooltipLink from '@/components/jobDetailed/zammadTicketPage/AffiliatedJobsTooltipLink.vue';

@Component({
  components: {
    AffiliatedJobsDialogLink,
    AffiliatedJobsTooltipLink,
  },
})
export default class AffiliatedJobHeaderItem extends Vue {
  @Prop(String) public jobsString: string;

  public jobsArray: number[] = [];
  public isDialogs = false;

  @Watch('jobsString', { immediate: true })
  private watchJobs() {
    this.jobsArray = this.jobsString
      .split(',')
      .filter(jobId => jobId.trim())
      .map(jobId => Number(jobId));
  }
}
